import searchLocale from './en.json'

const en = {
  search: searchLocale,
}

export default en
